import request from "../request";

// 查询CA员工业绩
export const getCAPerformance = (params) => {
  return request.get(`/wecom/report/ca/performance`, { params });
};

// 查询店铺业绩
export const getSMStorePerformance = (storeId) => {
  return request.get(`/wecom/report/sm/store/${storeId}`);
};

// 店铺下15日趋势
export const getSMTrendReportByDay = (storeId) => {
  return request.get(`/wecom/report/sm/store/smTrendReportByDay/${storeId}`);
};

// 查看店铺下CA业绩
export const getSMStoreReportByCa = (storeId) => {
  return request.get(`/wecom/report/sm/store/smStoreReportByCa/${storeId}`);
};

// 查看当前登录用户的区域业绩
export const getRMPerformance = () => {
  return request.get(`/wecom/report/rm/region`);
};

// 区域业绩15日趋势
export const getRMTrendReportByDay = () => {
  return request.get(`wecom/report/rm/region/rmTrendReportByDay`);
};

// 查看店铺下CA业绩
export const getRMStorePerformance = () => {
  return request.get(`/wecom/report/rm/region/rmRegionReportByStore`);
};

// 获取顾客列表
export const getCustomersList = (params) => {
  // console.error("getCustomersList", params);
  return request.get(`/wecom/report/my-order-customer`, { params });
};

// 获取门店销售列表
export const getEmployeeList = (params) => {
  // console.error("getCustomersList", params);
  return request.get(`/wecom/employee/list`, { params });
};

// RM 查询店铺列表
export const getRMStoreList = () => {
  // console.error("getRMStoreList");
  return request.get(`/wecom/auth/rm/store-performance/list`);
};

// RM 查询店铺详情
export const getRMStoreDetail = (storeId) => {
  // console.error("getRMStoreDetail", storeId);
  return request.get(`/wecom/report/rm/store-performance/${storeId}`);
};

// RM 查询客人详情
export const getCustomerDetail = (customerExternalUserid) => {
  // console.error("getCustomerDetail", customerExternalUserid);
  return request.get(`/wecom/report/customer-detail/${customerExternalUserid}`);
};
